import { helloTradeClient } from '../api/axiosClient';
import { HT_ENDPOINTS } from '../api/endpoints';

export async function checkConsent(glid, ak) {
  try {
    const params = new URLSearchParams({ glid, ak });
    const response = await helloTradeClient.get(`${HT_ENDPOINTS.CHECK_CONSENT}?${params}`, {
      timeout: 8000,
    });
    return response.data;
  } catch (error) {
    console.error('checkConsent failed:', error);
    return null;
  }
}

export async function createConsent({ glid, ak }) {
  try {
    const response = await helloTradeClient.post(
      HT_ENDPOINTS.CREATE_CONSENT,
      { glid, ak },
      { headers: { 'Content-Type': 'application/json' }, timeout: 8000 }
    );
    return response.data;
  } catch (error) {
    console.error('createConsent failed:', error);
    return null;
  }
}
